/* global Config */

const configBase = {
  baseUrl: Config.base.catalogUrl,
  contentType: 'application/json',
  crossDomain: false,
  method: 'GET',
  responseType: 'json',
  timeout: 90000,
};

export const serviceConfig = {
  ALIASES: {
    ...configBase,
    path: 'genre/aliases',
  },
  ALIAS_DELETE: {
    ...configBase,
    method: 'DELETE',
    path: 'genre/aliases/remove',
  },
  ALIAS_ADD: {
    ...configBase,
    method: 'POST',
    path: 'genre/aliases/add',
  },
  NETWORK: {
    ...configBase,
    path: 'network/networks',
  },
  FIND_NETWORK: {
    ...configBase,
    path: 'network/{name}',
  },
  CREATE_NETWORK: {
    ...configBase,
    method: 'POST',
    path: '/network',
  },
  UPDATE_NETWORK: {
    ...configBase,
    method: 'PUT',
    path: '/network',
  },
  FOLDER: {
    ...configBase,
    params: {ignoreDataPackage: true},
    path: 'folders/featured',
  },
  FOLDER_VIEW: {
    ...configBase,
    path: 'folders/featured/name?name={folderData.name}',
  },
  ASSET_BY_RUID: {
    ...configBase,
    path: '/asset/ruid?ruid={ruid}',
  },
  ASSET_BY_GUID: {
    ...configBase,
    path: '/asset/guid?guid={guid}',
  },
  ASSET: {
    ...configBase,
    params: {offset: 0, limit: 25},
    path: 'asset/searchAssets',
  },
  ASSETS: {
    ...configBase,
    params: {offset: 0, limit: 25},
    path: 'asset/assets',
  },
  UPDATE_ASSETS: {
    ...configBase,
    method: 'POST',
    path: 'asset',
  },
  CREATE_FOLDER: {
    ...configBase,
    method: 'PUT',
    path: 'folders/featured',
  },
  DELETE_FOLDER: {
    ...configBase,
    method: 'DELETE',
    path: 'folders/featured',
  },
  UPDATE_FOLDER: {
    ...configBase,
    method: 'POST',
    path: 'folders/featured',
  },
  STOREFRONT: {
    ...configBase,
    path: '/storefronts',
  },
  CREATE_STOREFRONT: {
    ...configBase,
    method: 'POST',
    path: '/storefronts',
  },
  DELETE_DATA_PACKAGE: {
    ...configBase,
    method: 'DELETE',
    path: 'asset/deleteDataPackage',
  },
  UPDATE_STOREFRONT: {
    ...configBase,
    method: 'PUT',
    path: '/storefronts',
  },
  NETWORK_KAFKA_UPDATES: {
    ...configBase,
    method: 'POST',
    baseUrl: '/kafka/',
    path: 'vca/produce',
  },
};

export const categories = [
  {code: 0, name: 'All Categories', short: 'ALL'},
  {code: 1, name: 'Movie', short: 'MOVIE'},
  {code: 2, name: 'Adult', short: 'ADULT'},
  {code: 4, name: 'TV Entertainment', short: 'TVENT'},
];
